import type { RouteObject } from "react-router";
import { DetailStack } from "@/components/detail-stack";
import type { DetailStackDrawer } from "@/components/detail-stack";
import { CustomerDetail } from "@/features/customer/customer-detail/CustomerDetail";
import { JobDetail } from "@/features/job/job-detail/JobDetail";
import { JobRun } from "@/features/job/job-run/JobRun";
import { OrderDetail } from "@/features/order/order-detail/OrderDetail";
import { getDetailSearch } from "./detailKind";
import type { DetailKind } from "./detailKind";

const DETAIL_DRAWERS: Record<DetailKind, DetailStackDrawer> = {
  orders: { component: OrderDetail, hasId: true },
  customers: { component: CustomerDetail, hasId: true },
  jobs: { component: JobDetail, hasId: true },
  run: { component: JobRun, size: "compact" },
};

/**
 * The detail stack's route, mounted under any page that opens details (children: [detailStackRoute]
 * plus an <Outlet /> in the page): everything after the page's path is the drawer stack,
 * e.g. /order/list/orders/<id>/customers/<id>.
 */
export const detailStackRoute: RouteObject = {
  path: "*",
  element: (
    <DetailStack
      drawers={DETAIL_DRAWERS}
      getSearch={getDetailSearch}
    />
  ),
};
